import { checkIcon } from 'globals/assets';
import { errorColor } from 'globals/colors';

export default {
  input: {
    border: '1px solid transparent',
    borderColor: '#4EB96F',
    outline: 'none',
    padding: '5px 10px',
    borderRadius: 12,
    display: 'inline',
    borderRight: 'none',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    flex: 1,
    margin: 0,
  },
  submit: {
    border: '1px solid transparent',
    borderColor: 'rgb(78, 185, 111)',
    padding: '0 2px 1px 1px',
    borderLeft: 'none',
    background: '#fff',
    borderTopRightRadius: '15px',
    borderBottomRightRadius: '15px',
    flex: 0,
    display: 'flex',
  },
  submitIcon: {
    background: `url('${checkIcon}') #4EB96F`,
    backgroundSize: 12,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '3px',
    height: 18,
    width: 18,
    borderRadius: 25,
    marginTop: 2,
    cursor: 'pointer',
  },
  submitError: {
    borderColor: errorColor,
  },
  submitErrorIconWrap: {
    borderColor: errorColor,
    pointerEvents: 'none',
  },
  submitErrorIcon: {
    opacity: 0.5,
  },
};
